import { render, staticRenderFns } from "./EditNameDialog.vue?vue&type=template&id=11816d0d"
import script from "./EditNameDialog.vue?vue&type=script&lang=js"
export * from "./EditNameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2940541101/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11816d0d')) {
      api.createRecord('11816d0d', component.options)
    } else {
      api.reload('11816d0d', component.options)
    }
    module.hot.accept("./EditNameDialog.vue?vue&type=template&id=11816d0d", function () {
      api.rerender('11816d0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EditNameDialog.vue"
export default component.exports